import React from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { RootState } from "../../../../redux/store";
import BackButton from "../../../../components/BackButton";
import { navigatedToPreviousStep } from "../../../../redux/slice/temporaryStorage/temporaryStorageSlice";

interface TemStorageNavigateBackActionProps {}

const TemStorageNavigateBackAction: React.FC<TemStorageNavigateBackActionProps> = () => {
  const dispatch = useDispatch();
  const step = useSelector((state: RootState) => state.temporaryStorage.step);

  const showBackButton = step !== 0;

  const handleBackClick = () => {
    dispatch(navigatedToPreviousStep());
  };

  return <BackButton hidden={!showBackButton} onClick={handleBackClick} />;
};

export default TemStorageNavigateBackAction;
